import React from 'react';

import styles from './collapsible-option.scss';

export default class CollapsibleOption extends React.Component {
  constructor(props) {
    super(props);
    this.toggleOpen = this.toggleOpen.bind(this);
    this.clickHandler = this.clickHandler.bind(this);

    this.state = {open: props.open || false};
  }

  componentWillReceiveProps(props) {
    this.setState({open: props.open});
  }

  toggleOpen() {
    const isCurrentlyOpen = this.state.open;
    this.setState({open: !isCurrentlyOpen});
  }

  clickHandler(event) {
    if (event.target.classList.contains('action-control')) {
      this.props.actionControl(this.props.value);
    } else {
      this.toggleOpen();
    }
  }

  render() {
    let collapsedContent;
    if (this.state.open) {
      collapsedContent = (
        <div className={styles.content}>
          {this.props.children}
        </div>
      );
    }

    const accordionDirection = this.state.open ? 'down' : 'right';

    return (
      <div className={this.props.containerClass}>
        <div
          className={styles.label}
          style={this.props.style}
          onClick={this.clickHandler}
        >
          <span className={`${styles.chevron} svg-ico-accordion-${accordionDirection}`} />
          <div className={styles.text}>
            {this.props.value}
          </div>
          {this.props.actionControlIcon || null}
        </div>
        {collapsedContent}
      </div>
    );
  }
}

CollapsibleOption.propTypes = {
  value: React.PropTypes.string,
  style: React.PropTypes.object,
  open: React.PropTypes.bool,
  children: React.PropTypes.any,
  actionControl: React.PropTypes.func,
  containerClass: React.PropTypes.string,
  actionControlIcon: React.PropTypes.node,
};



// WEBPACK FOOTER //
// ./src/components/dropdown/collapsible-option.jsx